/** Message and stack of a thrown value, which a route can throw as anything. */
export function errorDetails(error: unknown): {
  message?: string;
  stack?: string;
} {
  return error instanceof Error
    ? { message: error.message, stack: error.stack }
    : {};
}
